import { getStore, removeStore, setStore } from "@/util/store";

const workOrderStore = {
  state: {
    // 工单详情
    macWorkOrder: {},
    // 当前机型
    macWorkOrderMacType: "",
    // 当前工单详情工艺
    macWorkOrderMetMaterialCookTech: "",
    // 当前工单详情基本信息
    macWorkOrderMacWorkDetailsGoods: {},
    // 当前工单具体数据
    macWorkOrderMacWorkDetailsMsg: {},
    // 工单操作日志
    macWorkOrderOperateLogs: [],
    // 工单机器数据
    macWorkOrderStatisticParameter: {},
    // 当前tab
    macWorkOrderCurrentSelectTab: "1",
    // 最新完成工单ID（轮询判断避免重复刷新）
    finishWorkOrderId: null,
    // 进入工单详情的入口类型（1=常规入口，2=boss入口）
    enterType: 0,
  },

  actions: {
    // 保存工单详情接口的值
    saveMacWorkOrder({ commit }, data) {
      commit("SET_MAC_WORK_ORDER", data);

      commit(
        "SET_MAC_WORK_ORDER_MAC_WORK_DETAILS_GOODS",
        data && data.macWorkDetailsGoods ? data.macWorkDetailsGoods : {}
      );
      commit(
        "SET_MAC_WORK_ORDER_MAC_TYPE",
        data.macWorkDetailsGoods.machineType
          ? data.macWorkDetailsGoods.machineType
          : ""
      );
      commit(
        "SET_MAC_WORK_ORDER_MET_MATERIAL_COOK_TECH",
        data && data.metMaterialCookTech ? data.metMaterialCookTech : ""
      );
      commit(
        "SET_MAC_WORK_ORDER_MAC_WORK_DETAILS_MSG",
        data && data.macWorkDetailsMsg ? data.macWorkDetailsMsg : {}
      );
      commit(
        "SET_MAC_WORK_ORDER_OPERATE_LOGS",
        data && data.operateLogs ? data.operateLogs : []
      );
      commit(
        "SET_MAC_WORK_ORDER_STATISTIC_PARAMETER",
        data && data.statisticParameter ? data.statisticParameter : {}
      );
    },

    setMacWorkOrderCurrentSelectTab({ commit }, tab) {
      commit("SET_MAC_WORK_ORDER_CURRENT_SELECT_TAB", tab);
    },

    // 保存最新完成工单ID（轮询去重）
    saveFinishWorkOrderId({ commit }, id) {
      commit("SET_FINISH_WORK_ORDER_ID", id);
    },

    // 保存入口类型（不同入口走不同接口）
    saveWorkOrderEnterType({ commit }, t) {
      commit("SET_ENTER_TYPE", t);
    },
  },

  mutations: {
    SET_MAC_WORK_ORDER(state, payload) {
      state.macWorkOrder = payload;
    },
    SET_MAC_WORK_ORDER_MAC_TYPE(state, payload) {
      state.macWorkOrderMacType = payload;
    },
    SET_MAC_WORK_ORDER_MAC_WORK_DETAILS_GOODS(state, payload) {
      state.macWorkOrderMacWorkDetailsGoods = payload;
    },
    SET_MAC_WORK_ORDER_MAC_WORK_DETAILS_MSG(state, payload) {
      state.macWorkOrderMacWorkDetailsMsg = payload;
    },
    SET_MAC_WORK_ORDER_OPERATE_LOGS(state, payload) {
      state.macWorkOrderOperateLogs = payload;
    },
    SET_MAC_WORK_ORDER_STATISTIC_PARAMETER(state, payload) {
      state.macWorkOrderStatisticParameter = payload;
    },
    SET_MAC_WORK_ORDER_MET_MATERIAL_COOK_TECH(state, payload) {
      state.macWorkOrderMetMaterialCookTech = payload;
    },
    SET_MAC_WORK_ORDER_CURRENT_SELECT_TAB(state, payload) {
      state.macWorkOrderCurrentSelectTab = payload;
    },
    SET_FINISH_WORK_ORDER_ID(state, payload) {
      state.finishWorkOrderId = payload;
    },
    SET_ENTER_TYPE(state, payload) {
      state.enterType = payload;
    },
  },
};

export default workOrderStore;
